export default __webpack_public_path__ + "static/media/dogecoin.614a2a56.png";